export default class VacanciesListService {
  /**
   * Принимает массив партнеров
   * Возвращает отсортированный по убыванию массив партнеров
   */

  static getAllPartners(partners) {
    const filteredPartners = partners.slice();
    const allPartners = {
        id: -1,
        name: "Все партнеры",
        logo: '',
        sort: 999999999999999
    }
    filteredPartners.push(allPartners)
    return filteredPartners.sort((a, b) => b.sort - a.sort);
  }

  /**
   * Принимает массив партнеров
   * Возвращает массив объектов партнеров
   */

  // TODO: убрать toString
  static getOptionPartners(partnersList) {
    const optionsPartners = []
    partnersList.map(i => {
      const optionsPartner = {
        label: i.name,
        value: i.id.toString(),
      }
      return optionsPartners.push(optionsPartner)
    })
    return optionsPartners
  }

  // TODO: убрать toString
  static getFilteredParams(params) {
    return Object.fromEntries(Object.entries(params).filter(([key, val]) => (val.length ? val : val.toString()) !== '-1'))
  }

  /**
   * Принимает массив, где первый элемент ключ, а второй значение и пустой массив парамметров
   * Возвращает объект c параметрами
   */

  static updateParamsFromURL(pairParams, params) {
    params.push(pairParams)

    return Object.fromEntries(params)
  }

  /**
   * Принимает объект window.location
   * Возвращает отформатированный объект с параметрами запроса из урла
   */

  static getFormattedParamsFromUrl(vacancyURL) {
    let searchParams = new URLSearchParams(vacancyURL.search);
    const params = []
    let formattedParams;

    for(const pairParams of searchParams.entries()) {
      formattedParams = this.updateParamsFromURL(pairParams, params);
    }

    return formattedParams
  }

  /**
   * Принимает объект параметров
   * Возвращает обновленный урл с get параметрами запроса
   */

  static updateURL(params) {
    // create new url
    const location = window.location
    const vacancyURL = new URL(location)

    // add parameters for url
    vacancyURL.searchParams.set('sort', params.sort)
    params.sponsor_ids ? vacancyURL.searchParams.set('sponsor_ids', params.sponsor_ids) : vacancyURL.searchParams.delete('sponsor_ids')

    // add parameters in url
    return history.pushState(null, null, vacancyURL.href)
  }

  /**
   * Возвращает объект параметров из урла, если параметры запроса есть в урле
   */

  static getParamsFromUrl() {
    const location = window.location
    const vacancyURL = new URL(location)
    const params = this.getFormattedParamsFromUrl(vacancyURL)
    const formattedParams = {
      'per-page': 4,
      is_active: 1,
      sort: '-created_at',
      page: 1,
      ...params
    }

    return formattedParams
  }

}
